<template>
	<div class="ui-df" @focusout="onFocusOut" tabindex="0">
		<!--
		Если из выпадающего списка что-то выбрали,
		тогда показываем анимацию для label
		-->
		<div
			v-if="selectItem !== SELECTED.EMPTY && selectItem !== SELECTED.ALL"
			class="ui-df__anim"
		>
			{{ label }}
		</div>

		<div class="ui-df__elm" @click="onClick">
			<!-- SELECTED VALUE -->
			<div class="ui-df__elm-selected">
				<IconSearch
					v-if="isShowIcon"
					class="ui-df__elm-selected-icon"
					color="rgb(119, 121, 124)"
					width="16"
					height="16"
				/>
				<div
					v-if="
						selectItem === SELECTED.EMPTY ||
						selectItem === SELECTED.ALL
					"
				>
					{{ label }}
				</div>
				<div v-else>{{ selectItem }}</div>
			</div>
			<IconChevronDown />
		</div>

		<!-- Dropdown -->
		<div v-if="isShow" class="ui-df__list">
			<div class="ui-df__list-item" @click="onClickSelect('all', 0)">
				{{ dropdownDefaultLabel }}
			</div>
			<div class="ui-df__list-line"></div>
			<div
				@click="onClickSelect(item.name, item.id)"
				class="ui-df__list-item"
				v-for="(item, index) in items"
				:key="index"
			>
				{{ item.name }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconSearch from "@/components/icons/IconSearch.vue";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";

@Options({
	components: { IconChevronDown, IconSearch },
	props: {
		label: { type: String, default: "" },
		dropdownDefaultLabel: { type: String, default: "Выбрать всё" },
		items: { type: Array, default: [] },
		isShowIcon: { type: Boolean, default: true },
	},
})
export default class UiDropdownFilter extends Vue {
	public SELECTED = {
		EMPTY: "",
		ALL: "all",
	};

	public isShow = false;
	public selectItem = "";

	/**
	 * Показываем/скрываем выпадающий список
	 */
	public onClick() {
		this.isShow = !this.isShow;
	}

	/**
	 * Выбор значения из выпадающего списка
	 * @param item
	 * @param id
	 */
	public onClickSelect(item: string, id: number) {
		this.isShow = !this.isShow;
		this.selectItem = item;
		this.$emit("filter", id);
	}

	/**
	 * Скрываем выпадающий список, если кликнули за его пределами
	 */
	public onFocusOut() {
		this.isShow = false;
	}
}
</script>

<style scoped lang="scss">
.ui-df {
	user-select: none;
	position: relative;

	&__anim {
		position: absolute;
		top: -15px;
		font-size: 12px;
		color: rgb(51, 51, 51);

		// Анимация
		animation-duration: 0.4s;
		animation-name: appearance-animation-search;
	}

	&__elm {
		display: flex;
		justify-content: space-between;
		cursor: pointer;
	}

	&__elm-selected {
		display: flex;
	}

	&__elm-selected-icon {
		margin-right: 10px;
	}

	&__list {
		position: absolute;
		top: 30px;
		width: 100%;
		padding: 8px 0;
		background: rgb(255, 255, 255);
		border: 1px solid rgb(221, 221, 221);
		border-radius: 12px;
		max-height: 150px;
		overflow-y: auto;
		scrollbar-width: thin;
	}

	&__list-item {
		padding: 6px 12px;
		color: rgb(51, 51, 51);
		cursor: pointer;
	}

	&__list-item:hover {
		background: rgb(225, 225, 225);
		border-radius: 4px;
	}

	&__list-line {
		border-bottom: 1px solid rgb(243, 242, 242);
	}
}

@keyframes appearance-animation-search {
	0% {
		opacity: 0;
		transform: translate(0px, 10px);
		left: 0;
		right: 0;
	}
	100% {
		opacity: 1;
		transform: translate(0, 0);
		left: 0;
		right: 0;
	}
}
</style>
